var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check task completed",
    clipPath: "url(#clip0_2069_3938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle--geometric-circle-round-design-shape-shapes-shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.04283 16.0681C10.013 16.0681 11.9025 15.2854 13.2956 13.8923C14.6888 12.4992 15.4714 10.6097 15.4714 8.63951C15.4714 6.66933 14.6888 4.77984 13.2956 3.38672C11.9025 1.99359 10.013 1.21094 8.04283 1.21094C6.07265 1.21094 4.18316 1.99359 2.79004 3.38672C1.39691 4.77984 0.614258 6.66933 0.614258 8.63951C0.614258 10.6097 1.39691 12.4992 2.79004 13.8923C4.18316 15.2854 6.07265 16.0681 8.04283 16.0681Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.5666 5.40137L6.99519 11.1157L4.70947 9.40137",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2069_3938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.307129 0.639526)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCheckIcon);
export default __webpack_public_path__ + "static/media/white-check-icon.af3954b8d3ab218fb3edf50eaad536e7.svg";
export { ForwardRef as ReactComponent };